export function getCompanyAgeCategory(startDate) {
  if (!startDate) return null;

  const start = new Date(startDate);
  const now = new Date();

  const diffYears = now.getYear() - start.getYear();

  if (diffYears < 1) return 'Menos de 1 ano';
  if (diffYears < 2) return 'De 1 a 2 anos';
  if (diffYears < 5) return 'De 2 a 5 anos';
  if (diffYears < 10) return 'De 5 a 10 anos';
  
  return 'Mais de 10 anos';
}
